import './App.css';
import React, { useEffect, useState } from 'react';
import AppRouter from './router/AppRouter';
import { ThemeProvider } from './theming/ThemeContext';
import MobileBlocker from './components/mobileBlocker/MobileBlocker.jsx';
import { useDeviceType } from './utilities/deviceDetect.js';

const TABLET_BYPASS_KEY = 'ww_mobileBlocker bypass';

function AppGate() {
  const device = useDeviceType();
  const [tabletBypass, setTabletBypass] = useState<boolean>(() => {
    try { return sessionStorage.getItem(TABLET_BYPASS_KEY) === '1'; } catch { return false; }
  });

  useEffect(() => {
    // Reset bypass if user rotates to desktop
    if (device === 'desktop' && tabletBypass) {
      try { sessionStorage.removeItem(TABLET_BYPASS_KEY); } catch {}
      setTabletBypass(false);
    }
  }, [device, tabletBypass]);

  if (device === 'phone') {
    return <MobileBlocker variant="phone" />;
  }
  if (device === 'tablet' && !tabletBypass) {
    return (
      <MobileBlocker
        variant="tablet"
        onContinue={() => {
          try { sessionStorage.setItem(TABLET_BYPASS_KEY, '1'); } catch {}
          setTabletBypass(true);
        }}
      />
    );
  }
  return <AppRouter />;
}

function App() {
  return (
    <ThemeProvider>
      <AppGate />
    </ThemeProvider>
  );
}

export default App;
